import { ProductFPL } from '~/shared/constants/products';

/**
 * Gets the list of FPL (Featured Product Location) IDs that should be excluded from the grid.
 * This function handles exclusion of products based on various criteria like hidden products,
 * clearance sales, and user membership status.
 *
 * @param {boolean} options.autoExcludeClearanceFplIds - Whether to automatically exclude clearance FPL IDs based on user membership
 * @param {string} options.tld - Top-level domain (e.g., '.com', '.co.uk') to determine regional FPL settings
 * @param {boolean} options.isVip - Whether the user is a VIP member (affects which sale FPLs are excluded)
 * @returns {Array<number>} Array of unique FPL IDs to exclude from the grid
 */
export default function getExclusionFpls({
  autoExcludeClearanceFplIds,
  tld,
  isVip,
}) {
  const hideFromGridFpl = ProductFPL.hideFromGrid?.[tld] || ProductFPL.hidden;
  const excludeFplsSet = new Set([hideFromGridFpl]);

  if (autoExcludeClearanceFplIds) {
    const leadFplId = ProductFPL.leadSaleFpls?.[tld];
    const vipFplId = ProductFPL.vipSaleFpls?.[tld];
    if (isVip) {
      if (vipFplId) {
        excludeFplsSet.add(vipFplId);
      }
    } else {
      if (leadFplId) {
        excludeFplsSet.add(leadFplId);
      }
    }
  }

  return Array.from(excludeFplsSet);
}
